<template>
  <v-layout justify-center align-center v-if="customer">
    <div>
      <v-alert
        role="alert"
        type="info"
        v-if="
          customer && customer.admin && Object.keys(customer.admin).length === 0
        "
        dismissible
        >Google is deprecating JavaScript Platforms API. You have to
        <strong>re-authenticate</strong> with a
        <a target="_blank" :href="`${$backendUrl}/info`"
          >Google Workspace advanced administrator account here</a
        >
        for <strong>Trelson Mail Switch</strong> to work in the future. You have
        {{
          parseInt(
            (new Date("2023-03-31").getTime() - new Date().getTime()) /
              (1000 * 3600 * 24)
          )
        }}
        days left.
      </v-alert>
    </div>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      customer: "customer/customer",
    }),
  },
};
</script>
